import 'firebase/firestore';

export default {
  name: 'ResHubCoreBundle',
  props: {
    settings: null,
    arecheckedesdisabled: Boolean,
    facility: null
  },
  created() {
    this.sendDefaultValueForModule();
  },
  computed: {
    resHubCoreBundle: {
      get() {
        return this.conciergeCategory && this.lifestyleCategory;
      }
    },
    conciergeCategory: {
      get() {
        return (
          (this.facility.additionalServicesEnabled ?? true) &&
          (this.facility.additionalServicesBookingsEnabled ?? true) &&
          (this.facility.canFamilyChargeToRoom ?? true) &&
          (this.facility.canFamilyPayByCard ?? true) &&
          (this.facility.isStaffHubConcierge ?? true)
        );
      }
    },
    lifestyleCategory: {
      get() {
        return (
          (this.facility.calendarEnabled ?? true) &&
          (this.facility.familyTimelineEnabled ?? true) &&
          (this.facility.communityEnabled ?? true) &&
          (this.facility.isEnablePrintCalendar ?? true) &&
          (this.facility.isEnableCalendarFeed ?? true) &&
          (this.facility.isEnableWeeklyLifestyleEventsReport ?? true) &&
          (this.facility.isStaffHubCalendar ?? true) &&
          (this.facility.isStaffHubPrintableCalendar ?? true) &&
          (this.facility.isStaffHubLifestylePrograms ?? true)
        );
      }
    },
  },
  watch: {
    resHubCoreBundle() {
      this.$emit('send-bundle-value', this.resHubCoreBundle)
    }
  },
  methods: {
    sendDefaultValueForModule() {
      this.$emit('send-bundle-value', this.resHubCoreBundle)
    },
    resHubCoreBundleUpdate(value) {
      this.conciergeCategory = value;
      this.lifestyleCategory = value;
      this.conciergeCategoryUpdate(value);
      this.lifestyleCategoryUpdate(value);
    },
    conciergeCategoryUpdate(value) {
      this.facility.additionalServicesEnabled = value;
      this.facility.additionalServicesBookingsEnabled = value;
      this.facility.canFamilyChargeToRoom = value;
      this.facility.canFamilyPayByCard = value;
      this.facility.isStaffHubConcierge = value;
    },
    lifestyleCategoryUpdate(value) {
      this.facility.calendarEnabled = value;
      this.facility.familyTimelineEnabled = value;
      this.facility.communityEnabled = value;
      this.facility.isEnablePrintCalendar = value;
      this.facility.isEnableCalendarFeed = value;
      this.facility.isEnableWeeklyLifestyleEventsReport = value;
      this.facility.isStaffHubCalendar = value;
      this.facility.isStaffHubPrintableCalendar = value;
      this.facility.isStaffHubLifestylePrograms = value;
    }
  }
};